import React, { memo, useMemo, useEffect, useContext } from 'react';
import CommonSourceCard from './components/CommonSourceCard';
import { useRequest } from 'ahooks';
import { fetchStudioOverallProjectsBudgetCardData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { getFormatNumPlusOfUSD, formatDateStr } from '@gp/utils/common';
import { CONSTANT_TEXTS } from '@gp/constants/const';
import { context as Context } from '@gp/components/Context';
import dollarIcon from '@gp/assets/svg/gameInformation/dollar.svg';
import './index.scss';

interface BudgetPropsType {}

const DEFAULT_PROPS: BudgetPropsType = {};

function Budget(props: BudgetPropsType) {
  const {} = props;

  const { filter }: StudioOverallProjectsContextType =
    useContext(Context) || {};

  const { loading, data, run } = useRequest(
    fetchStudioOverallProjectsBudgetCardData,
    { manual: true },
  );

  const chartOpt = useMemo(() => {
    const yearBudgetYear = formatDateStr(data?.year_budget_date, 'YYYY');
    const budgetSpentToDateYear = formatDateStr(data?.budget_date, 'YYYY');
    return [
      {
        // title: '2023 Budget',
        title: yearBudgetYear ? `${yearBudgetYear} Budget` : 'Budget',
        value: getFormatNumPlusOfUSD(data?.year_budget),
        isDate: false,
        date: '',
        count: data?.year_budget_include,
        isSolt: true,
        soltTitle: `${CONSTANT_TEXTS.APPROVED_DEVELOPMENT_BUDGET_SIMPLE}:`,
        soltV: getFormatNumPlusOfUSD(data?.total_budget),
        isNoData: !data?.year_budget && !data?.total_budget,
      },
      {
        title: budgetSpentToDateYear ? `${budgetSpentToDateYear} Budget Spent to Date` : 'Budget Spent to Date',
        value: getFormatNumPlusOfUSD(data?.year_budget_spent_to_date),
        isDate: true,
        date: data?.budget_date
          ? `${data?.budget_date?.substring(
              0,
              4,
            )}-01 ~ ${data?.budget_date?.substring(0, 7)}`
          : '',
        count: data?.year_budget_spent_to_date_include,
        isSolt: true,
        soltTitle: 'Total Budget Spent to Date:',
        soltV: getFormatNumPlusOfUSD(data?.total_budget_spent_to_date),
        isNoData:
          !data?.year_budget_spent_to_date && !data?.total_budget_spent_to_date,
      },
      {
        title: 'Last Month Spent',
        value: getFormatNumPlusOfUSD(data?.last_month_spent),
        isDate: true,
        date: data?.budget_date?.substring(0, 7) || '',
        count: data?.last_month_spent_include,
        isSolt: false,
        soltTitle: '',
        soltV: '',
        isNoData: !data?.last_month_spent,
      },
    ];
  }, [loading]);

  // 筛选器变化
  useEffect(() => {
    run({
      bo: filter?.bo || [],
      project: filter?.project || [],
    });
  }, [filter]);

  return (
    <div
      className="dbg-studio-overall-projects-development-budget"
      // title="Budget"
    >
      <div className="dbg-studio-overall-projects-development-budget-title">
        Budget
      </div>
      <div
        className="dbg-studio-overall-projects-development-budget-context"
        // title="Budget"
      >
        {chartOpt?.map((t) => {
          return (
            <CommonSourceCard
              key={t?.title}
              isLoading={loading}
              isNoData={t?.isNoData}
              icon={<img src={dollarIcon} alt="" />}
              title={t?.title}
              value={t?.value}
              date={t?.date}
              count={t?.count}
              isDate={t?.isDate}
              slot={
                t?.isSolt ? (
                  <section className="dbg-studio-overall-projects-development-budget-card-footer">
                    <span className="dbg-studio-overall-projects-development-budget-card-footer-label">
                      {t?.soltTitle}
                    </span>
                    <span className="dbg-studio-overall-projects-development-budget-card-footer-value">
                      {t?.soltV || '-'}
                    </span>
                  </section>
                ) : null
              }
            />
          );
        })}
      </div>
    </div>
  );
}

Budget.defaultProps = DEFAULT_PROPS;

export default memo(Budget);
